import classNames from 'classnames'
import { map, toSafeInteger } from 'lodash'

import { useMutation } from '@apollo/client'
import { msg } from '@lingui/macro'
import { useLingui } from '@lingui/react'

import styles from './index.module.css'
import MUTATION from './set-authorization.graphql'

const authOptions = {
  1: msg`Con permessi di lettura`,
  3: msg`Con permessi di gestione`,
}

const LevelButton = ({ id, level, user, disabled = false }) => {
  const { _ } = useLingui()
  const [mutate] = useMutation(MUTATION, {
    refetchQueries: ['GetElementAuthorizationForUsers'],
  })

  const onChange = ({ target }) => {
    return mutate({
      variables: {
        object: id,
        user,
        value: toSafeInteger(target.value),
      },
    })
  }

  return (
    <select
      className={classNames([styles.select, 'form-select'])}
      defaultValue={level}
      onChange={onChange}
      disabled={disabled}
      style={{ height: 'max-content' }}
    >
      {map(authOptions, (name, value: number) => (
        <option key={value} value={value}>
          {_(name)}
        </option>
      ))}
    </select>
  )
}

export default LevelButton
